import { Routes, Route } from "react-router-dom";
import VendorQuotationCreateScreen from "screens/App/CRM/VendorQuotation/VendorQuotationCreateScreen";
import VendorQuotationDetailScreen from "screens/App/CRM/VendorQuotation/VendorQuotationDetailScreen";
import VendorQuotationEditScreen from "screens/App/CRM/VendorQuotation/VendorQuotationEditScreen";
import VendorQuotationListScreen from "screens/App/CRM/VendorQuotation/VendorQuotationListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const VendorQuotationRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<VendorQuotationListScreen />} />
      <Route path="create" element={<VendorQuotationCreateScreen />} />
      <Route path=":id/detail" element={<VendorQuotationDetailScreen />} />
      <Route path=":id/edit" element={<VendorQuotationEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VendorQuotationRouter;
